import { useEffect, useState } from 'react';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import { NavigateFunction, useLocation } from 'react-router-dom';
import { browserName, browserVersion, osName } from "react-device-detect";

// Apis
import { saveApi } from '../../../api/saves';

// Config
import ENV from '../../../config/env.json';

// Context
import { useAuthStore } from '../../../context/Auth';
import { useTranslationStore } from '../../../context/Translation';

// Enums
import { CategoryTypes } from '../../../enums/Categories';
import { LanguageResource } from '../../../enums/Languages';
import { RoutesLinks } from '../../../enums/Routes';
import { SwalIcons, SwalTitle } from '../../../enums/Swal';

// Interfaces
import { EventInterface } from '../../../interfaces/Event';

// Utils
import DateUtil from '../../../utils/DateUtil';
import JSUtil from '../../../utils/JSUtil';

interface PropsInterface {
  event:  EventInterface;
  navigate: NavigateFunction;
};

const EventInfoSave = (props: PropsInterface) => {
  const [saved, setSaved] = useState(props.event.saved),
    [authState] = useAuthStore(),
    [t] = useTranslationStore(),
    location = useLocation();
  let isSaving = false;

  useEffect(() => {
    setSaved(props.event.saved);
  }, [props.event.saved]);

  const saveEvent = (e: any, saved: boolean) => {
    e.stopPropagation();
    if (authState.loggedIn) {
      if (!JSUtil.isEmpty(props.event) && props.event) {
        if (!isSaving) {
          isSaving = true;
          saveApi(
            {
              token: authState.token,
              body: {
                type: CategoryTypes.Events,
                id: props.event._id,
                companyId: props.event.company.by,
                saved,
                track: {
                  //@ts-ignore
                  origin: location?.state?.origin || '',
                  //@ts-ignore
                  info: location?.state?.info || '',
                  platform: 'web',
                  model: browserName,
                  brand: osName,
                  systemVersion: browserVersion,
                  appVersion: ENV.WEB_VERSION
                },
              },
            },
            (err: any) => {
              if (err) {
                isSaving = false;
                Swal.fire({
                  icon: SwalIcons.Error as SweetAlertIcon,
                  title: t(SwalTitle.Error),
                  text: err,
                });
              } else {
                setSaved(saved);
                isSaving = false;
                if (saved) {
                  if (!props.event.claim?.text && !DateUtil.isTodayAfterDate(props.event.startDate)) {
                    Swal.fire({
                      icon: SwalIcons.Success as SweetAlertIcon,
                      title: t(LanguageResource.Events + ':saved_title'),
                      text: t(LanguageResource.Events + ':saved_text')
                    }).then(() => {
                      if (props.event.claim?.url) {
                        window.open(props.event.claim?.url, "_blank");
                      }
                    });
                  } else if (props.event.claim?.url) {
                    window.open(props.event.claim?.url, "_blank");
                  }
                }
              }
            },
          );
        }
        }
    } else {
      Swal.fire({
        title: t(LanguageResource.Common + ':login_needed_title'),
        text: t(LanguageResource.Common + ':login_needed_text'),
        showCancelButton: true
      }).then(result => {
        if (result.isConfirmed) {
          props.navigate(RoutesLinks.Login.Link);
        }
      });
    }

  };
  return (
    <div className='button-wrapper'>
      {
        saved
        ?
        <div className='disabled-button-wrapper' onClick={(e) => saveEvent(e, !saved)}>
          <p className='disabled-button-text'>{
            props.event.claim?.text
            ? props.event.claim.text
            : t(LanguageResource.Events + ':interested')}
          </p>
        </div>
        : 
        <div className='primary-button-wrapper' onClick={(e) => saveEvent(e, !saved)}>
          <p className='primary-button-text'>{
            props.event.claim?.text
            ? props.event.claim.text
            : t(LanguageResource.Events + ':interested')}
          </p>
        </div>
      }
    </div>
  );
};

export default EventInfoSave;